import { render, staticRenderFns } from "./BillSubTable.vue?vue&type=template&id=9dc4680c&scoped=true&"
import script from "./BillSubTable.vue?vue&type=script&lang=ts&"
export * from "./BillSubTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc4680c",
  null
  
)

export default component.exports